import type { Ref } from "vue";
import type { FolderNavJs } from "@/generated/models";
import { computed } from "vue";

export function getWorkspaceFromLocation(location: FolderNavJs) {
  const root = location.breadcrumbJson.at(0);
  if (!root) return;

  return {
    id: root.id,
    folderId: root.fsRootFolderId,
    name: root.name,
    isDefault: root.isDefaultFs,
  };
}

function getParentFromLocation(location: FolderNavJs) {
  const parent = location.breadcrumbJson.at(-2);
  if (!parent) return;

  if (parent.isFilesystem && parent.fsRootFolderId) {
    return {
      id: parent.fsRootFolderId,
      name: parent.name,
    };
  }

  return {
    id: parent.id,
    name: parent.name,
  };
}

function getOrganizationFromLocation(location: FolderNavJs) {
  const root = location.breadcrumbJson.at(0);
  if (!root) return;

  return {
    id: root.subInstanceId,
  };
}

export function getLocationParts(location: FolderNavJs) {
  const organization = getOrganizationFromLocation(location);
  const workspace = getWorkspaceFromLocation(location);
  const parent = getParentFromLocation(location);
  const isInWorkspaceRoot = !!parent?.id && !!workspace?.folderId && parent.id === workspace.folderId;
  const path = location.breadcrumbJson.map(d => d.id);
  const ancestors = location.breadcrumbJson.slice(0, -1);

  return {
    organization,
    workspace,
    parent,
    ancestors,
    path,
    isInWorkspaceRoot,
  };
}

export function useLocationParts(location: Ref<FolderNavJs | undefined>) {
  const parts = computed(() => {
    if (!location.value) return;
    return getLocationParts(location.value);
  });

  const organization = computed(() => parts.value?.organization);
  const workspace = computed(() => parts.value?.workspace);
  const parent = computed(() => parts.value?.parent);
  const isInWorkspaceRoot = computed(() => parts.value?.isInWorkspaceRoot);
  const path = computed(() => parts.value?.path);
  const ancestors = computed(() => parts.value?.ancestors);

  return {
    parts,
    organization,
    workspace,
    parent,
    ancestors,
    path,
    isInWorkspaceRoot,
  };
}
